// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"249f3d97","421":"b3a301b9","854":"32473eae"}[chunkId] + ".chunk.js";
};